<script setup>
import {ref, watch} from 'vue';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
  activeTab: {
    type: [Number, String],
    default: 1,
  },
  contentClass: {
    type: String,
    default: '',
  },
  align: {
    type: String,
    default: 'stretch',
  },
});
const emit = defineEmits(['update:activeTab']);

const localActiveTab = ref(props.activeTab);

const setActiveTab = (tabId) => {
  localActiveTab.value = tabId;
  emit('update:activeTab', tabId);
};

watch(() => props.activeTab, (newVal) => {
  setActiveTab(newVal);
});
</script>

<template>
  <div class="tabs">
    <div class="tabs__items" :class="{ 'tabs__items--start': align === 'start' }">
      <div
          v-for="tab in tabs"
          :key="tab.id"
          class="tab"
          :class="{ active: localActiveTab === tab.id }"
          @click="setActiveTab(tab.id)"
      >
        {{ tab.label }}
        <span v-if="tab.badge" class="tab__badge">{{ tab.badge }}</span>
      </div>
    </div>

    <div class="tabs__content" :class="contentClass">
      <slot :active="localActiveTab"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  .tabs__items {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .tab {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 10px 20px;
      font-weight: 500;
      color: #555;
      border-bottom: 1px solid #ccc;
      cursor: pointer;

      &.active {
        border-bottom: 2px solid #5E2F78;
        color: #000;
        font-weight: 600;
      }
    }

    &--start {
      justify-content: flex-start;

      .tab {
        width: auto;
      }
    }
  }

  .tabs__content {
    flex: 1;
  }
}

.tab__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  margin-left: 6px;
  border-radius: 999px;
  background: #C0392B;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.qna-tabs-content {
  overflow-y: scroll;
}
</style>
